import React, { useEffect, useState } from 'react'

import { twMerge } from 'tailwind-merge'

interface FilterHeader {
  onReset: () => void
  count?: number
}

const FilterHeader: React.FC<FilterHeader> = ({ onReset, count = 0 }) => {
  const [showChip, setShowChip] = useState<boolean>(count > 0)

  useEffect(() => {
    // need this logic in order to make sure the chip doesn't show up
    // before the showReset icon button shows up (e.g. a weird layout shift)
    // due to the upstream expensive count calculations that occur every time the filter values change
    if (count > 0) {
      const timeoutId = setTimeout(() => {
        setShowChip(true)
      }, 25)
      return () => clearTimeout(timeoutId)
    } else {
      setShowChip(false)
    }
  }, [count])

  return (
    <div className={twMerge('flex flex-col w-full gap-y-2 px-2')}>
      <div className="flex w-full items-start xl:items-start justify-between pl-2 pr-[1px] py-2 h-10">
        <div
          className={twMerge(
            'flex items-center justify-between w-full gap-x-2 gap-y-1 pr-1',
          )}
        >
          <span className="text-md font-bold text-primary-900 dark:text-primary-100">
            Filters
          </span>
          {showChip && count > 0 && (
            <button
              type="button"
              onClick={onReset}
              className="flex hover:opacity-70"
            >
              <span className="text-sm text-primary-600 dark:text-primary-300">
                {`Clear (${count})`}
              </span>
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

export default FilterHeader
